import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './Buttons.scss'

const EditIconButton = (props) => {
    const {className, onClick} = props;
    const resultingClassName = classnames(styles.editButton, className);
    return <button type='button' className={resultingClassName} onClick={onClick} />;
};

EditIconButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};
EditIconButton.defaultProps = {
    className: null,
};

export default EditIconButton;



// WEBPACK FOOTER //
// ./src/components/controls/buttons/EditIconButton.jsx